export default "__VITE_ASSET__6dcc4f7b__"